//import { apiRequest } from "./ActionUtils"

export function depositFundsInit(id) {
  return function(dispatch) {
    window.forceTokenSync = true;
  }
}